import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem} from '../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../shared/Models/columns';
import * as moment from 'moment';
import {Router} from '@angular/router';
import {IButton} from '../../../shared/card/card.component';
import {AuthenticationService} from '../../../shared/Services/authentication.service';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../environments/environment';
import {Invoice} from '../../../back-office/Models/Invoice';
import {InvoiceService} from '../../Services/invoice.service';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {NgbCountryDateParserFormatter} from '../../../shared/Services/NgbCountryDateParserFormatter';
import {Helper} from '../../../helpers/helper.service';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbCountryDateParserFormatter}
  ],
})

export class InvoiceComponent implements OnInit {
  public grid: Grid;
  public specialButton: IButton[] = [];
  public specialButtonArray;
  public baseUrl = environment.apiUrl;
  public params;
  public invoice = new Invoice();
  @ViewChild('customerPriceTemp', {static: true}) customerPriceTemp;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  @ViewChild('statusTemplate', {static: true}) statusTemplate;
  @ViewChild('typeTemplate', {static: true}) typeTemplate;
  @ViewChild('dueDateTemplate', {static: true}) dueDateTemplate;
  public dateFormat;

  constructor(private invoiceService: InvoiceService, private router: Router, private auth: AuthenticationService,
              private translator: TranslateService, private helper: Helper) {
  }

  ngOnInit() {
    if (this.auth.isDealerUser()) {
      this.auth.logout();
      return;
    }
    this.dateFormat = this.auth.getDateFormat();
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.invoice.number',
          prop: 'id',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          width: 100,
        },
        <TextColumn>{
          name: 'doctrine.invoice.date',
          prop: 'created',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          width: 50,
          valueFormatter: row => moment(row).format(this.dateFormat),
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.due_date',
          prop: 'dueDate',
          sortable: true,
          type: TextColumn.type,
          minWidth: 230,
          translate: true,
          valueTemplate: this.dueDateTemplate,
          valueFormatter: row => {
            if (!row) {
              return '-';
            }
            return moment(row).format(this.dateFormat);
          },
        },
        <TextColumn>{
          name: 'doctrine.invoice.amount',
          prop: 'amount',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          width: 50,
          valueTemplate: this.customerPriceTemp,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          width: 200,
          maxWidth: 300,
          translate: true,
          valueTemplate: this.statusTemplate
        },
        <TextColumn>{
          name: 'doctrine.invoice.type',
          prop: 'status',
          sortable: false,
          type: TextColumn.type,
          width: 200,
          maxWidth: 300,
          translate: true,
          valueTemplate: this.typeTemplate
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          width: 100,
          actionItems: [
            <ActionItem>{
              name: 'global.download',
              icon: '',
              status: true,
              tooltip: 'global.download',
              onclick: row => {
                this.invoiceService.getPdfInvoice(row.id).subscribe((resp) => {
                  if (resp && typeof resp === 'object') {
                    this.helper.createDownloadLink(resp.url, resp.filename);
                  }
                });
              },
              showCallback: row => row,
              btnClass: ''
            },
          ]
        }
      ],
      service: this.invoiceService,
      rememberURL: this.router.url,
      method: 'getInvoices',
      root: 'invoice',
      defaultSort: 'id',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          calendarFromDate: 'from',
          calendarToDate: 'to',
          hasCalendar: true,
          isInvoiceStatus: true,
          label: 'doctrine.attributes.model',
          hasDropdownListFilter: false,
          hasStatus: true,
          hasNormalSearch: true,
        }
      ],
    };

    this.specialButtonArray = [
      {name: 'Download', btnIcon: 'feather icon-download', method: 'Download', customClass: 'btn-grey'},
    ];
    this.specialButtonArray.forEach(items => {
      this.specialButton.push({
        btnIcon: items.btnIcon,
        btnName: items.name,
        btnUrl: items.btnUrl,
        method: items.method,
        btnCustomClass: items.customClass
      });

    });
  }
  setParams(event) {
    this.params = event;
  }
  calFunction(method: string) {
    this[method]();
  }

  downloadOrderPdf(id) {
    this.invoiceService.getPdf(id).subscribe((resp: {url: string, filename: string}) => {
      const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
      el.setAttribute('href', resp.url);
      el.setAttribute('download', resp.filename);
      el.click();
    });
  }

  Download() {
    this.invoiceService.downloadInvoices(this.params).subscribe((pdfData: ArrayBuffer) => {
      const blob = new Blob([pdfData], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url);
    });
  }

  calculateOverdueDays(date) {
    let now = moment();
    now = moment(now, 'YYYY/MM/DD');
    const dueDate = moment(date, 'YYYY/MM/DD');
    return now.diff(dueDate, 'days');
  }
  formatDateString(date) {
    return moment(date).format(this.dateFormat);
  }
}
